/* eslint-disable @typescript-eslint/naming-convention */
import axios from 'axios';
import {
  CATALOG_ENTRIES_API,
  CATALOG_POLICY_MAP_API,
  COURSE_CATALOG_API,
  ENTITLEMENTS_OFFERING,
  FIXED_CATALOG_ENTRIES_API,
} from 'config/constants';
import { CatalogEntry, CatalogPolicies, LegacyCatalog } from 'types';

const { get } = axios;

/**
 * Used for RHLS
 * @returns catalog entries specific to that subscription
 */
export const getCatalog = async (subscription: string) => {
  if (!subscription) {
    throw new Error('Subscription code required');
  }

  try {
    const catalog = await get(`${COURSE_CATALOG_API}${subscription}`);
    const { catalog_entries: catalogEntries } = catalog.data;

    return catalogEntries;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Get old catalog containing live classes
 */
export const getLegacyCatalog = async (): Promise<LegacyCatalog> => {
  try {
    const entitlementsOffering = await get(ENTITLEMENTS_OFFERING);
    const { data } = entitlementsOffering;
    return data as LegacyCatalog;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Used for a la carte
 * @returns catalog entries
 */
export const getCatalogEntries = async () => {
  try {
    const entries = await get(CATALOG_ENTRIES_API);
    const { items } = entries.data;

    return items;
  } catch (error) {
    throw error;
  }
};

export const getCatalogEntriesV2 = async () => {
  try {
    const response = await get<{ fixed_catalog: CatalogEntry[] }>(
      FIXED_CATALOG_ENTRIES_API,
    );
    // this endpoint has http cache, but browser should
    // handle it automatically and the status will be 200 to the perspective of axios.
    const { fixed_catalog } = response.data;

    return fixed_catalog;
  } catch (error) {
    throw error;
  }
};

export const getCatalogPolicyMap = async () => {
  try {
    const response = await get<CatalogPolicies>(CATALOG_POLICY_MAP_API);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default getCatalog;
